module.exports = __webpack_public_path__ + "static/yqhy_btn.e49d51d8.png";